<section>
    <div class="subMenu">
        <span class="tex_menu" *ngFor="let item of breaddata ;let i=index" >
          <a href="{{item.url}}">{{item.name}}</a>
          <span *ngIf="i!=2"> |</span>
        </span>
    </div>
</section>
